export default {"src":"/_next/static/media/finCorpBranch.771afc52.svg","height":63,"width":63,"blurWidth":0,"blurHeight":0};